import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-scroll';
export function About() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [1, 1, 0, 0]);
  return <section id="about" className="py-12 sm:py-16 md:py-20 bg-[#0a1628] relative" ref={ref} data-id="element-20">
      {/* Subtle gold divider line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent opacity-30" data-id="element-21" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-23">
          {/* Left - Image */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8
        }} className="relative order-2 md:order-1" data-id="element-24">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hatPzCSGkYCPvVwK9FiFUk/Untitled_Design_832x1248.png" alt="Renova8 & Build team member in Brisbane" className="w-full rounded-lg shadow-2xl relative z-10" data-id="element-25" />
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 bg-[#d4af37] rounded-lg -z-10 opacity-20" data-id="element-26" />
          </motion.div>
          {/* Right - Text */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 md:order-2" data-id="element-27">
            <motion.h2 style={{
            opacity
          }} className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-28">
              Who <span className="text-[#d4af37]" data-id="element-29">We Are</span>
            </motion.h2>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6" data-id="element-30">
              Renova8 & Build delivers luxury renovation and smart home
              solutions across Brisbane. We combine modern design, premium
              finishes, and smart technology to create homes that are beautiful,
              functional, and future-ready.
            </p>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8" data-id="element-31">
              Our team brings luxury, quality, and futuristic design to every
              project, whether it is a renovation or a new build. We are
              committed to transforming your vision into reality with precision
              and innovation.
            </p>
            <Link to="contact" smooth={true} duration={500} className="inline-flex items-center gap-2 bg-transparent text-[#d4af37] px-6 py-3 rounded-full font-semibold border border-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a1628] transition-all duration-300 cursor-pointer" data-id="element-32">
              Meet The Team
            </Link>
            <div className="grid grid-cols-3 gap-3 sm:gap-4 md:gap-6 mt-8" data-id="element-33">
              <div className="text-center" data-id="element-34">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#d4af37] mb-1 sm:mb-2" data-id="element-35">
                  500+
                </h3>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base" data-id="element-36">
                  Projects
                </p>
              </div>
              <div className="text-center" data-id="element-37">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#d4af37] mb-1 sm:mb-2" data-id="element-38">
                  15+
                </h3>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base" data-id="element-39">
                  Years
                </p>
              </div>
              <div className="text-center" data-id="element-40">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#d4af37] mb-1 sm:mb-2" data-id="element-41">
                  100%
                </h3>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base" data-id="element-42">
                  Satisfaction
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}